import React from 'react';
import styled from 'styled-components';
import { SectionParent, H2, H1 } from '../../StyledComponents';
import BirdSong from '../../../assets/v2/Health/birdsong.png';
import SpireHealth from '../../../assets/v2/Health/spirehealth.png';
import SpireLogo from '../../../assets/v2/Health/spirelogo.png';
import RomLogo from '../../../assets/v2/Health/romlogo.png';
import Rom from '../../../assets/v2/Health/rom.png';
import BirdLogo from '../../../assets/v2/Health/birdlogo.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background: #f4f6fb;
  padding-bottom: 5rem !important;
  padding-top: 3rem !important;
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 768px) {
    padding-top: 9px;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  @media (max-width: 350px) {
    padding: 0;
    padding-bottom: 2rem !important;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: 10rem;
`;
const StyledImgLogo = styled(LazyLoadImage)`
  height: 40px;
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 1rem;
  padding: 3rem;
  padding-bottom: 1rem;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0;
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.a`
  grid-column: span 1;
  border-radius: 5px;
  max-width: 80%;
  border-radius: 4px;
  box-shadow: 0 3px 18px 0 rgba(72, 82, 108, 0.15);
  background: #ffffff;
  padding: 2rem;
  cursor: pointer;
  padding-bottom: 0.5rem;
  justify-self: center;
  transition: transform 0.3s ease-in;
  :hover {
    transform: scale(1.05);
  }
  @media (max-width: 1100px) {
    margin-bottom: 2rem;
    justify-self: center !important;
  }
  @media (max-width: 768px) {
    max-width: 90%;
    justify-self: center;
    padding-bottom: 1rem;
  }
  @media (max-width: 400px) {
    padding: 0.5rem;
  }
`;
const GridItemRight = styled(GridItem)`
  justify-self: start;
  margin-left: 2rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-left: 0;
  }
`;
const GridItemContent = styled(H2)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  /* font-size: 14px; */
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  @media (max-width: 768px) {
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  @media (max-width: 768px) {
    justify-items: center;
  }
`;
const ImgWrapperLogo = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  @media (max-width: 768px) {
    justify-items: center;
  }
`;

const SectionTitle = styled(H1)`
  padding-top: 2rem;
  font-weight: bold;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  @media (max-width: 1100px) {
    margin-bottom: 2rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    margin-bottom: 0rem;
  }
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
`;
export default () => (
  <>
    <Section>
      <SectionTitle>
        Leading healthcare innovation clients trust Esper
      </SectionTitle>
      <GridContainer>
        <GridItem
          href="https://birdsonglife.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ justifySelf: 'end' }}
        >
          <ImgWrapper>
            <StyledImg src={BirdSong} />
          </ImgWrapper>
          <ImgWrapperLogo>
            <StyledImgLogo src={BirdLogo} />
          </ImgWrapperLogo>
          <GridItemContent>
            Affordable, easy-to-use tablet specifically designed to entertain
            and engage Seniors.
          </GridItemContent>
        </GridItem>
        <GridItem href="https://www.romtech.com/" target="_blank">
          <ImgWrapper>
            <StyledImg src={Rom} />
          </ImgWrapper>
          <ImgWrapperLogo>
            <StyledImgLogo src={RomLogo} />
          </ImgWrapperLogo>
          <GridItemContent>
            Pedaling therapy immediately post-surgery for better outcomes and
            pain management.
          </GridItemContent>
        </GridItem>
        <GridItem
          href="https://spirehealth.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ justifySelf: 'start' }}
        >
          <ImgWrapper>
            <StyledImg src={SpireHealth} />
          </ImgWrapper>
          <ImgWrapperLogo>
            <StyledImgLogo src={SpireLogo} />
          </ImgWrapperLogo>
          <GridItemContent>
            Telehealth for chronic respiratory conditions, combining wearable,
            clinical-grade monitoring with a smartphone interface for patient
            engagement.
          </GridItemContent>
        </GridItem>
      </GridContainer>
    </Section>
  </>
);
